import React, { useEffect, useRef } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CareerVideoModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 h-[100vh] m-0 bg-black/70 bg-opacity-10 flex items-center justify-center z-[120] p-10">
      <div className="bg-transparent w-fit rounded-lg animate-in fade-in duration-200 p-5">
        <div
          className="py-10 sm:my-7 lg:my-10 flex justify-center"
          ref={modalRef}
        >
          {/* replace this with the video  https://youtu.be/ijLOuLiJzgY?si=HswgLKwvcgKdzmu5 */}
          <div className="max-w-lg md:max-w-2xl xl:h-[637px] flex justify-center items-center xl:max-w-[70rem]">
            <iframe
              title="YouTube video player"
              src="https://www.youtube.com/embed/gGLbwdHPPzI?si=AnLUdZY6uzct98iT"
              className="max-w-lg md:max-w-2xl h-[12rem] sm:h-[19rem] md:w-[34rem] rounded-2xl xl:max-w-[70rem] lg:w-[60rem] xl:h-[637px] xl:w-[70rem] lg:h-[28rem] sm:w-[29rem]"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerVideoModal;
